import { sensorTitles } from '@eaphone/analyze/config.ts';

export default {
  component: () => import('./page.vue'),
  path: '/analysis/:sensorType',
  name: 'analysis',
  meta: {
    title: '健康数据',
    titleKey: 'sensorType',
    titleMaps: sensorTitles,
    auth: true,
  },
};
